import React, { useRef, useEffect, useContext } from 'react';
import {useTheme} from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import {isLogin,getPrivileges} from '../../functions/Auth';
import { NavLink, useHistory } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import '../../scss/components/_panel_details.scss';
import Chip from '@material-ui/core/Chip';
import ReactEcharts from 'echarts-for-react';
import CircleIcon from '@material-ui/icons/FiberManualRecord';
import Modal from '@material-ui/core/Modal';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { loadModules } from 'esri-loader';
import API_PATH from "../../constants/config.json";
import Cookies from 'js-cookie';

import VolumeChart from '../StationDetails/Midblock/VolumeChart';
import SpeedChart from '../StationDetails/Midblock/SpeedChart';
import ClassificationChart from '../StationDetails/Midblock/ClassificationChart';
import FileList from '../StationDetails/FileList';
import DetailsOptions from '../StationDetails/DetailsOptions';
import NoDetails from '../StationDetails/NoDetails';

import StationCard from '../StationDetails/Midblock/StationCard';
import SummaryCard from '../StationDetails/Midblock/SummaryCard';
import ChartCard from '../StationDetails/Midblock/ChartCard';
import DetailsCard from '../StationDetails/Midblock/DetailsCard';
import SummaryVolume from '../StationDetails/Midblock/SummaryVolume';
import SummarySpeed from '../StationDetails/Midblock/SummarySpeed';

import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import HomeIcon from '@material-ui/icons/Home';
import PublicFilesCard from '../StationDetails/PublicFilesCard';
import MapContext from '../../context/MapContext';

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Start Css code ...
const useStyles = makeStyles((theme) => ({}))

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

//Start MidBlock component code ...
const MidBlock = props => {
  const { isKph } = useContext( MapContext )
  const { checkExportValue } = props;
    useEffect(() => {        
    }, [props.searchPanel]);
    let msWidth = window.innerHeight;
    const mapRef = useRef();  
    const theme = useTheme();
  // This code is use to get window viewport height
  if (window.screen.width >= 100 && window.screen.width <= 1500) {
    msWidth = window.innerWidth;
  }
  else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
    msWidth = window.innerWidth;
  }
  else if (window.screen.width >= 3501) {
    msWidth = window.innerWidth;
  }
  else {
    msWidth = window.innerWidth;
  }    

  const volumeCountDate = (props.data && props.hasData && props.data.midblockStationRecentYear.hasOwnProperty('volumeyear'))?props.data.midblockStationRecentYear.volumeyear:null;
  const volumeClassCountDate = (props.data && props.hasData && props.data.midblockStationRecentYear.hasOwnProperty('classyear'))?props.data.midblockStationRecentYear.classyear:null;
  const traffiSpeedCountDate = (props.data && props.hasData && props.data.midblockStationRecentYear.hasOwnProperty('speedyear'))?props.data.midblockStationRecentYear.speedyear:null;
  
  const yearList = (props.data && props.hasData && props.data.midblockSummaryData[0])?props.data.midblockSummaryData[0].adt:[];
  const getADTSummery = (props.data && props.hasData && props.data.midblockSummaryData[0])?props.data.midblockSummaryData[0].adt:[];
  const getTruckPercent = (props.data && props.hasData && props.data.midblockSummaryData[1])?props.data.midblockSummaryData[1].truckpercent:[];
  const getADTGrowthFactor = (props.data && props.hasData && props.data.midblockSummaryData[2])?props.data.midblockSummaryData[2].growthrate:[];
  const getDFactor = (props.data && props.hasData && props.data.midblockSummaryData[3])?props.data.midblockSummaryData[3].d_factor:[];
  const getKFactor = (props.data && props.hasData && props.data.midblockSummaryData[4])?props.data.midblockSummaryData[4].k_factor:[];
  const getPeakHr = (props.data && props.hasData && props.data.midblockSummaryData[5])?props.data.midblockSummaryData[5].peak_hour:[];
  const getPeakDir = (props.data && props.hasData && props.data.midblockSummaryData[6])?props.data.midblockSummaryData[6].peak_dir:[];
  const getLOS = (props.data && props.hasData && props.data.midblockSummaryData[7])?props.data.midblockSummaryData[7].los:[];
  
  
  const eChartYear = (props.data && props.hasData && props.data.midblockADTeChart.hasOwnProperty('eChartYear'))?props.data.midblockADTeChart.eChartYear:[];
  const eChartData = (props.data && props.hasData && props.data.midblockADTeChart.hasOwnProperty('eChartData'))?props.data.midblockADTeChart.eChartData:[];
  const eChartTrendLineData = (props.data && props.hasData && props.data.midblockADTeChart.hasOwnProperty('eChartTrendLineData'))?props.data.midblockADTeChart.eChartTrendLineData:[];
  const eChartGet = (props.data && props.hasData && props.data.midblockADTeChart.hasOwnProperty('eChartGet'))?props.data.midblockADTeChart.eChartGet:0;
  const getchart = (props.data && props.hasData && props.data.midblockADTeChart.hasOwnProperty('etchart'))?props.data.midblockADTeChart.etchart:[];

  let tmpCountYear = eChartYear.length >= 2 ? eChartYear[eChartYear.length-1] - eChartYear[0] : 0;

  const [midBlockScreenWidth, setMidBlockScreenWidth] = React.useState(msWidth);
  const [stationList, setStationList] = React.useState([]);    
  const [totalItems, setTotalItems] = React.useState(0);
  const [userAccess, setUserAccess] = React.useState(true);    
  const [getLoader, setLoaderDisable] = React.useState(false);
  let enteriesPerPage = 50;

  const [openAllDetails, setOpenAllDetails] = React.useState(false);    
  const handleCloseAllDetails = () => setOpenAllDetails(false);
  const [tabValue, setTabValue] = React.useState(0);
  const handleChangeTab = (event, newValue) => {
      if(newValue == 0){
        loadMap();
      }
      setTabValue(newValue);
  };
  const [tabValueDataType, setTabValueDataType] = React.useState(0);
  const handleChangeTabDataType = (event, newValue) => {      
      setTabValueDataType(newValue);
  };

  const [getResponseData, setResponseData] = React.useState([]);
  const [dateArr, setDateArr] = React.useState([]);
  const [dateVal, setDateVal] = React.useState([]);
  const [selectedDate, setSelectedDate] = React.useState([]);
  const [dataType, setDataType] = React.useState('Volume');

  const [getData, setData] = React.useState({});
  const [getCombinedData, setCombinedData] = React.useState([{ amPeakHour: 0, amPeakVolume: 0 }, { pmPeakHour: 0, pmPeakVolume: 0 }]);
  const [getNBData, setNBData] = React.useState([{ amPeakHour: 0, amPeakVolume: 0 }, { pmPeakHour: 0, pmPeakVolume: 0 }]);
  const [getSBData, setSBData] = React.useState([{ amPeakHour: 0, amPeakVolume: 0 }, { pmPeakHour: 0, pmPeakVolume: 0 }]);

  const [getSpeedData, setSpeedData] = React.useState([]);
  const [getDirectionSpeedName, setDirectionSpeedName] = React.useState('');
  const [getDirectionSpeedCombine, setDirectionSpeedcombine] = React.useState('');
  const [getDirectionSpeedNameTab, setDirectionSpeedNameTab] = React.useState('');

  const [getClassData, setClassData] = React.useState();
  const [getDirectionClassCombine, setDirectionClasscombine] = React.useState('');
  const [getDirectionClassName, setDirectionClassName] = React.useState('');
  const [getDirectionClassNameTab, setDirectionClassNameTab] = React.useState('');
  
  const [getDirectionName, setDirectionName] = React.useState('NB');
  const [getDirectionNameTab, setDirectionNameTab] = React.useState('SB');

  const [volumeHasData, setVolumeHasData] = React.useState(false);
  const [speedHasData, setSpeedHasData] = React.useState(false);
  const [classHasData, setClassHasData] = React.useState(false);
  const [scrolled, setScrolled] = React.useState(false);
  const panelRef = useRef();
  const [zoom, setZoom] = React.useState(null);
  const [shadowHeader, setShadowHeader] = React.useState(false);

  const myOptions = {
        color: ["#71717A"],
        title: {
          text: null
        },
        grid: {          
          bottom: '35px',
          top: '20px',          
          left:'35px',
          right: '25px'
        },
        tooltip: {
          trigger: 'item',    
          formatter: (params, index) => {
            let res = '';
            let colorCumulative = ['#696969', '#428adc'];
            var colorSpan = (color) => '<span style="display:inline-block;margin-right:5px;margin-top:5px;border-radius:10px;width:9px;height:9px;float:left;background-color:' + color + '"></span>';
            if ((params.componentType == "series") && (params.componentSubType == 'line')) {
              res += '<span style="float:left">' + parseFloat(params.data[0]) + '</span>' +
                ' <br/>' + colorSpan(colorCumulative[1]) + '<span style="float:left">' + params.data[2] + '</span>';
            }
            return res;
          }
    
        },
        legend: {
          data: []
        },
        xAxis: [{
          type: "value",
          interval: 1,
          min: (eChartYear.length > 1 ? Math.min(...eChartYear) : (eChartYear[0]) - 1),
          max: (eChartYear.length > 1 ? Math.max(...eChartYear) : (eChartYear[0]) + 1),
          splitLine: {
            show: true,
            lineStyle: {              
              color: '#F4F4F5',              
              width: 1
            }
          },
          axisLine : {
            show : false
          },
          axisTick : {
            show : false
          },
          axisLabel: {
            rotate: tmpCountYear > 10 ? 45 : 0,            
            fontSize: 8,            
            formatter: function (value, index) {
              return parseInt(value.toString().replace(",", ""));
            }
          },
    
        }],
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {              
              color: '#F4F4F5',              
              width: 1
            }
          },
          axisLine : {
            show : false
          },
          axisTick : {
            show : false
          },
          axisLabel: {            
            fontSize: 8,            
          },
          scale: true
        },
        series: [
          {
            name: 'Volume Growth',
            type: 'line',
            symbolSize: 6,
            color: "#2563EB",
            colorAlpha: "#2563EB",
            data: getchart,
            lineStyle: {
              type: 'solid',
              color: "#2563EB",
              width: 2
            },
          },
          {
            type: 'line',
            data: eChartTrendLineData,
            symbol: 'none',
            lineStyle: {
              type: 'dashed',
              color: "#7e9ed6",
              width: 2
            },
            label: {
              show: false
            },
          }
        ]
      };
    const handleOpenAllDetails = () => {
        setTabValue(0);
        setOpenAllDetails(true);
        loadMap();
        getFileList(); 
        getDateList();        
      }; 
      const getDateList = () => {
        setLoaderDisable(true);
        try {
            axios({
                method: 'post',
                data: {
                    "stationId": props.stationData.station_id
                },
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.getStationMBCountDateList
            }).then(async function (response) {
                if (response && response.data.data && response.data.data.length > 0) {
                    setLoaderDisable(false);
                    let tempArr = [];
                    let tempDateArr = [];
                    setResponseData(response.data.data);
                    response.data.data.map((val) => {
                        tempDateArr.push(val.send_date);
                        tempArr.push(val.date_count);
                    });
                    if(sessionStorage.getItem('midSelectedDate')) {
                        getAllVolumeData(sessionStorage.getItem('midSelectedDate'), response.data.data);
                        getAllSpeedData(sessionStorage.getItem('midSelectedDate'));
                        setSelectedDate(sessionStorage.getItem('midSelectedDate'))
                        getClassificationData(sessionStorage.getItem('midSelectedDate'));
                    } else {
                        setSelectedDate(tempDateArr[0]);                        
                        let reviewvolume = await getAllVolumeData(tempDateArr[0], response.data.data);
                        let reviwspeed = await getAllSpeedData(tempDateArr[0]);                        
                        let reviewclass = await getClassificationData(tempDateArr[0]); 
                        
                        reviewData(reviewvolume,reviwspeed,reviewclass);
                    }                  
                    setDateVal(tempDateArr);
                    setDateArr(tempArr);
                } else {
                    console.log("");
                    setLoaderDisable(false);
                }
            })
        }
        catch (error) {
            setLoaderDisable(false);           
        }
    }  
    const reviewData = (volume,speed,classd) =>{
      let volumeHasData = (Object.keys(volume).length>0)? true : false;
      let speedHasData = (Object.keys(speed).length>0)? true : false;
      let classHasData = (Object.keys(classd).length>0)? true : false;
      let tmpDataType = null;
      if( (tmpDataType == null || dataType === "Volume" ) && volumeHasData){
        tmpDataType = 'Volume';
      }
      if( (tmpDataType == null || dataType === "Classification" ) && classHasData){
        tmpDataType = 'Classification'
      }
      if( (tmpDataType == null || dataType === "Speed" ) && speedHasData){
        tmpDataType = 'Speed'
      }         
      setDataType(tmpDataType); 

      setVolumeHasData(volumeHasData);
      setSpeedHasData(speedHasData);
      setClassHasData(classHasData);
    }
      const loadMap = () => {
        // lazy load the required ArcGIS API for JavaScript modules and CSS
        loadModules(['esri/Map', 'esri/views/MapView', "esri/widgets/Locate", "esri/widgets/Home", "esri/widgets/Zoom", "esri/layers/FeatureLayer", "esri/Viewpoint", "esri/geometry/Point", "esri/Graphic", "esri/layers/GraphicsLayer", "esri/symbols/PictureMarkerSymbol", "esri/widgets/Search"], { css: true })
          .then(async ([ArcGISMap, MapView,Locate, Home, Zoom, FeatureLayer, Viewpoint, Point, Graphic, GraphicsLayer, PictureMarkerSymbol, Search]) => {
            const map = new ArcGISMap({
              basemap: (sessionStorage.getItem('baseMapType') !=null && sessionStorage.getItem('baseMapType') =='hybrid')?'hybrid':'streets-navigation-vector',
              slider: false
            });        
            let view = new MapView({
              container: mapRef.current,
              map: map,
              ui: {
                components: ['home', 'locate'] // specify only the components you want
              },
            });
            let zoom = new Zoom({
              view: view,
            });
            let featureLayer = new FeatureLayer({
              url: sessionStorage.getItem('mapURL')
            });
            featureLayer.when(function () { // adds feature layer to map view
              let vp = new Viewpoint({
                targetGeometry: featureLayer.fullExtent
              });
              view.extent = featureLayer.fullExtent;
    
            });
            setZoom(zoom);
            map.add(featureLayer);
            //let position = await getStationDetails();
            featureLayer.when(async function () { // adds feature layer to map view         
              // console.log('Logn :'+longitude+ 'Lat :'+latitude);          
              let point = new Point(props.stationData.longitude, props.stationData.latitude);          
              let pointSymbol = {
                type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                url: (props.sharedStation)?require("../../assets/icons/marker_Midblock_shared.png"):require("../../assets/icons/marker_Midblock.png"),
                width: "34px",
                height: "34px",
                yoffset: "20px"
              }
              let pointGraphic = new Graphic(point, pointSymbol);
              view.graphics.add(pointGraphic);
              view.goTo(pointGraphic).then(function () {
                view.zoom = view.zoom + 5;
                if(!props.hasData){
                  //view.graphics.remove(pointGraphic);
                }
              });
            });
    
          });
        }    
        const getFileList = () => { // API call to get all files
          setLoaderDisable(true);
          try {
            axios({
              method: 'post',
              data: {
                stationId: props.stationData.station_id,
                pageNo: 1,
                entriesPerPage: enteriesPerPage
              },
              headers: {
                'payload': Cookies.get('payload'),
                'agencyid': sessionStorage.getItem('agency_id')
              },
              url: API_URL + API_PATH.fileList,
            })
              .then(async function (response) {                
                if (response.status && response.status == '200') {
                  setLoaderDisable(false);
                  setStationList(response.data.data.rows);
                  setTotalItems(response.data.data.count);
                } else {
                  setStationList([]);
                  setLoaderDisable(false);
                }
              })
              .catch(function (error) {
                if (error.response) {
                  if (error.response.data.status == 403) {
                    setUserAccess(false);
                    setLoaderDisable(false);
                    setStationList([]);
                  } else {
                    setStationList([]);
                    setLoaderDisable(false);
                  }
                } else {
                  setStationList([]);
                  setLoaderDisable(false);
                }
              })
          } catch (error) {
            console.error(error);
            setLoaderDisable(false);
          }
        }      
    const getAllVolumeData = async (date = null, data) => {
      setLoaderDisable(true);
          try {
              return axios({
                  method: 'post',
                  data: {
                      "stationId": props.stationData.station_id,
                      "dateData": date ? date : selectedDate,
                  },
                  headers: {
                      'payload': Cookies.get('payload'),
                      'agencyid': sessionStorage.getItem('agency_id')
                  },
                  url: API_URL + API_PATH.getstationMBDetail,
              })
                  .then(async function (response) {
                      if (response.status && response.status == '200') {
                          setLoaderDisable(false);
                          let resData = data.filter((value, index) => {
                              return value.send_date == date;
                          })                          
                          //disableTab(resData[0]);
                          setData(response.data.data);
                          setCombinedData(response.data.data.dir12.peak);
                          setNBData(response.data.data.dir1.peak);                          
                          setSBData(response.data.data.dir2.peak);
                          setDirectionNameTab(response.data.data.dir2.direction)
                          setDirectionName(response.data.data.dir1.direction)

                          return response.data.data;
                      } else {
                          setLoaderDisable(false);
                          setCombinedData([]);
                          setNBData([]);
                          setSBData([]);
                          setData([]);
                          return [];
                      }
                  })
                  .catch(function (error) {
                      setLoaderDisable(false);
                      setCombinedData([]);
                      setNBData([]);
                      setSBData([]);
                      setData([]);
                      return [];
                  })
          } catch (error) {
              setLoaderDisable(false);
              setCombinedData([]);
              setNBData([]);
              setSBData([]);
              setData([]);
              return [];
          }
      }
      const getAllSpeedData = async (date = null) => {
        setLoaderDisable(true);
            try {
                return axios({
                    method: 'post',
                    data: {
                        "stationId": props.stationData.station_id,
                        "dateData": date ? date : selectedDate,
                        "isKph": await sessionStorage.getItem("isKph").toString() === "true" ? true : false
                    },
                    headers: {
                        'payload': Cookies.get('payload'),
                        'agencyid': sessionStorage.getItem('agency_id')
                    },
                    url: API_URL + API_PATH.getstationMBSpeedDetail,
                })
                    .then(async function (response) {
                        if (response.status && response.status == '200') {
                            setLoaderDisable(false);
                            setSpeedData(response.data.data)
                            setDirectionSpeedName(response.data.data.data1.dir1);
                            setDirectionSpeedcombine(response.data.data.combine.dir12);
                            setDirectionSpeedNameTab(response.data.data.data2.dir2);

                            return response.data.data;
    
                        } else {
                            setLoaderDisable(false);
                            setSpeedData([]);

                            return [];
                        }
                    })
                    .catch(function (error) {
                        setLoaderDisable(false);     
                        return [];                     
                    })
            } catch (error) {
                setLoaderDisable(false);
                console.error(error);
                return [];
            }
        }
        const getClassificationData = async (date = null) => {
          setLoaderDisable(true);
          try {
              return axios({
                  method: 'post',
                  data: {
                    "stationId": props.stationData.station_id,
                    "dateData": date ? date : selectedDate,
                  },
                  headers: {
                      'payload': Cookies.get('payload'),
                      'agencyid': sessionStorage.getItem('agency_id')
                  },
                  url: API_URL + API_PATH.getstationMBClassificationDetail,
  
              }).then(function (response) {
                  if (response && response.data.data) {
                      setLoaderDisable(false);
                      setClassData(response.data.data)                      
                      setDirectionClasscombine(response.data.data.combine.dir12)
                      setDirectionClassName(response.data.data.data1.dir1)
                      setDirectionClassNameTab(response.data.data.data2.dir2)

                      return response.data.data;
                  } else {
                      setLoaderDisable(false);
                      setClassData([]);                      
                      return [];
                  }                
              }).catch((err) => {
                  setLoaderDisable(false);
                  setClassData([]);                  
                  return [];
              })
          }
          catch (error) {
              setLoaderDisable(false);
              return [];
          }
      }      
      const dateChange = async (e) => {
          //sessionStorage.setItem('midSelectedDate',e.target.value);
          setSelectedDate(e.target.value);          

          let reviewvolume = await  getAllVolumeData(e.target.value, getResponseData);
          let reviwspeed = await  getAllSpeedData(e.target.value);                       
          let reviewclass = await getClassificationData(e.target.value);
          
          reviewData(reviewvolume,reviwspeed,reviewclass);
      } 
      const dataTypeChange = (e) => {        
        setDataType(e.target.value);
        //getAllVolumeData(e.target.value, getResponseData);
        //getAllSpeedData(e.target.value);
    } 
    //This function is used for export data
  const setExportData = () => {
    if(props.hasData) {
      props.groupStations(props.stationData.station_id, props.stationData.station_type, props.stationData.client_station_id, props.stationData.station_location);
      props.checkExportValue();
    }
  }

  //This function is used for export data
    
    const handleScroll = () => {
      if (panelRef.current) {
        const { scrollTop } = panelRef.current;
        if (scrollTop > 0) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      }
  };
  const homeEvent = () => { // event to go at initial view
    
  }
  const ZoomInEvent = () => { // event to zoom in map
    zoom.zoomIn();

  }
  const zoomOutEvent = () => { // event to zoom out map
    zoom.zoomOut();
  }
  const scrollHandle = (scroll) =>{    
    if(scroll.target.scrollTop>0){
      setShadowHeader(true);
    }else{
      setShadowHeader(false);
    }    
  }
    return (
        <React.Fragment>
          {(getPrivileges().length !== 0)?<div className='btn-menu-details' style={{marginTop:'-45px',marginRight:'10px'}}>
            <DetailsOptions modal={handleOpenAllDetails}
             checkExportValue={checkExportValue}
             setExportData={setExportData}
             hasData={props.hasData}
             stationData={props.stationData}
             handleStationDetails={props.handleStationDetails}
             />         
          </div>:null}
          <div className="station-details-main">
            <div className={'results-title-lbl'}> 
                <label className='station-list-lbl'>Midblock summary</label>
              </div>
           <div className={scrolled? 'station-details-info scrolled-el' :'station-details-info'} >                         
            <div className='panel-info-data' onScroll={handleScroll} ref={panelRef}>
            <StationCard clss={!props.hasData?'details-main-info details-main-no-data':'details-main-info'} fixed={true} sharedStation={props.sharedStation} sharedAgencyName={props.sharedAgencyName} stationData={props.stationData} volumeCountDate={volumeCountDate} volumeClassCountDate={volumeClassCountDate} traffiSpeedCountDate={traffiSpeedCountDate}/> 
            {(props.loadingDetails)?null:<>{(!props.hasData) ? 
              <div className='panel-info-data-wrap-no-data'>
                <NoDetails handleOpenAllDetails={handleOpenAllDetails} showButton={true} stationData={props.stationData} />
              </div>
            :<div className='panel-info-data-wrap'>
            {props.sharedStation?<Card className='tb-details-info tb-shared-info' style={{marginBottom:'15px'}}> 
              <img src={require('./../../assets/icons/shared_icon.svg')}/>
              <div className="tb-shared-info-lb">
                  <span>Shared</span>
                  <label title={props.sharedAgencyName}>This station is shared from {props.sharedAgencyName}</label>
              </div> 
            </Card>:null}
            {(yearList.length>0)?<> 
              <label className='info-sub-title'>Summary</label>
              <SummaryCard 
              yearList={yearList} 
              getADTSummery={getADTSummery}
              getTruckPercent={getTruckPercent}
              getADTGrowthFactor={getADTGrowthFactor}
              getDFactor={getDFactor}
              getKFactor={getKFactor}
              getPeakHr={getPeakHr}
              getPeakDir={getPeakDir}
              getLOS={getLOS}
            />     
            </>:null}       
            {(yearList.length>1)?<>
            <label className='info-sub-title'>ADT by year</label>
            <ChartCard eChartGet={eChartGet} myOptions={myOptions}/>
            </>:null}
            <label className='info-sub-title'>Details</label>
            <DetailsCard stationData={props.stationData}/> 
            {/*<label className='info-sub-title'>Description</label>
            <Card className='des-info-station' style={{}}>
                {(props.stationData && props.stationData.description)?props.stationData.description:null}
            </Card>*/}
            {
              props.stationData && props.stationData.miscellaneous ?
              <>
                <label className='info-sub-title'>Miscellaneous</label>
                <Card className='tb-details-miscellaneous'>
                  {props.stationData.miscellaneous}
                </Card>
              </>
              :null
            }
            <PublicFilesCard stationData={props.stationData}/>
            {(getPrivileges().length !== 0)?<Grid container>
              <Grid item xs={12} style={{textAlign: 'center',paddingBottom:'5px'}}>
                <a 
                className='btn-blue btn-view-all-details' 
                onClick={handleOpenAllDetails}><span>View all details</span></a>
              </Grid>            
            </Grid>:null}   
            </div>}</>}        
            </div>
            </div> 
            </div>  
            <Modal
            open={openAllDetails}
            onClose={handleCloseAllDetails}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"     
            className={'z_index_test'}       
          >
           <div className='md-all-details' style={tabValue==0?{width:'1000px',height:'90%'}:{width:'1264px',height:'90%'}}>
             <div className='md-header-details' style={shadowHeader?{boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)'}:{}}>
             <Tabs value={tabValue} onChange={handleChangeTab} className='tb-hd-main-opts' aria-label="basic tabs example">
              <Tab label="Station details" {...a11yProps(0)} />
              <Tab label="Traffic counts" {...a11yProps(1)} disabled={!props.hasData} />              
            </Tabs>  
            <div className='header-options-md'>
                <Button 
                  className='btn-blue btn-export-data' 
                  variant="contained" 
                  disabled={!props.hasData}
                  style={!props.hasData?{opacity:'0.5'}:{}}
                  onClick={setExportData}><img src={require('../../assets/icons/File - Download.svg')} style={{marginRight:'10px'}}/> 
                  Export
                </Button>   
                <NavLink target="_blank" to={{ pathname: '/midblock_details?station='+props.stationData.client_station_id+(props.sharedStation?'&by='+props.stationData.FK_agency_id:''), state: { clicked: true } }} className='btn-full-screen'>
                  <img src={require("./../../assets/icons/full_screen.svg")} />
                </NavLink>
                <IconButton aria-label="delete" className='btn-close-md' onClick={handleCloseAllDetails}>
                  <img src={require("./../../assets/icons/close.svg")} />  
                </IconButton>                              
              </div>                     
             </div>
             <div className='md-body-details' /* onScroll={(e) => scrollHandle(e)} */> 
             {props.sharedStation?<div className='tb-shared-info-mn'><Card className='tb-details-info tb-shared-info' style={{}}> 
                  <img src={require('./../../assets/icons/shared_icon.svg')}/>
                  <div className="tb-shared-info-lb">
                      <span>Shared</span>
                      <label>This station is shared from {props.sharedAgencyName}</label>
                  </div> 
                </Card></div>:null}
                <SwipeableViews
                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                        index={tabValue}
                        onChangeIndex={handleChangeTab}
              >
              <TabPanel value={tabValue} index={0} dir={theme.direction}>
                <div className='details-summary-map-files'> 
                  <div className='details-summary-map'>
                    <div className='details-summary'>
                      <div className='details-card'> 
                        <label className='info-sub-title'>Station</label>
                        <StationCard clss={!props.hasData?'details-main-info details-main-no-data':'details-main-info'} sharedStation={props.sharedStation} sharedAgencyName={props.sharedAgencyName} stationData={props.stationData} volumeCountDate={volumeCountDate} volumeClassCountDate={volumeClassCountDate} traffiSpeedCountDate={traffiSpeedCountDate}/>
                      </div>
                      {(yearList.length>0)?<div className='details-card'>
                      <label className='info-sub-title'>Summary</label>
                        <SummaryCard 
                          yearList={yearList} 
                          getADTSummery={getADTSummery}
                          getTruckPercent={getTruckPercent}
                          getADTGrowthFactor={getADTGrowthFactor}
                          getDFactor={getDFactor}
                          getKFactor={getKFactor}
                          getPeakHr={getPeakHr}
                          getPeakDir={getPeakDir}
                          getLOS={getLOS}
                        />
                      </div>:null}
                      {(!props.hasData)?<NoDetails stationData={props.stationData}/>:null}
                      {(props.hasData)?<div className='details-card'>
                        <label className='info-sub-title'>Details</label>
                        <DetailsCard stationData={props.stationData}/> 
                      </div>:null}
                      {(props.hasData && props.stationData.miscellaneous && yearList.length>1)?
                        <div className='details-card' style={{marginTop: '16px'}}>
                          <label className='info-sub-title'>Miscellaneous</label>
                          <Card className='info-details-miscellaneous'>
                            {props.stationData.miscellaneous}
                          </Card>
                        </div>
                      :null}
                      {/* {(yearList.length>1)?<div className='details-card'>
                        <label className='info-sub-title'>Average daily traffic chart</label>
                        <ChartCard eChartGet={eChartGet} myOptions={myOptions}/>
                      </div>:null} */}
                    </div>
                    <div className='details-map'>
                      <label>Map</label> 
                      <div className='details-map-cnt'> 
                        {/*!props.hasData?<div className='disabled-map' style={{height: '90%'}}></div>:null*/}
                        <div ref={mapRef} className={!props.hasData?'map-details-pn map-details-no-data':'map-details-pn'} data-testid='mapView' style={!props.hasData?{opacity:'1'}:{}}></div>
                        <Box display='flex' flexDirection="column" className="homeIconList" style={!props.hasData?{opacity:'1'}:{}}>
                          {/* <div data-testid="homeBtn" className="homeIcon" title="Home">
                            <HomeIcon onClick={() => homeEvent()} title="Home" />
                          </div>                         */}
                          <div data-testid="zoomInBtn" className="zoomIcon" style={{ marginBottom: '-3px' }} title="Zoom In">
                            <AddIcon onClick={() => ZoomInEvent()} title="Zoom In" />
                          </div>
                          <div data-testid="zoomOutBtn" className="inIcon" title="Zoom Out">
                            <RemoveIcon onClick={() => zoomOutEvent()} title="Zoom Out" />
                          </div>
                        </Box> 
                      </div>                      
                      {(props.hasData && yearList.length>1)?<div className='chart-details-pn' style={{marginTop:'16px'}}>
                        <div className='details-card'>                        
                          <label className='info-sub-title'>ADT by year</label>
                          <ChartCard eChartGet={eChartGet} myOptions={myOptions}/>                        
                        </div>
                      </div>:null}
                      {(props.hasData && props.stationData.miscellaneous && yearList.length<=1)?
                        <div className='details-card' style={{marginTop: '16px', width: '376px'}}>
                          <label className='info-sub-title'>Miscellaneous</label>
                          <Card className='info-details-miscellaneous'>
                            {props.stationData.miscellaneous}
                          </Card>
                        </div>
                      :null}
                    </div>                                      
                  </div>
                  <div className='tb-list-files-act' style={(yearList.length>1)?{marginBottom:'16px'}:{}}>
                      <Card className='card-file-list'>
                        <FileList list={stationList} getFileList={getFileList} fullscreen={false} stationData={props.stationData} sharedStation={props.sharedStation}/> 
                      </Card>
                  </div>
                </div>                   
              </TabPanel>
              <TabPanel value={tabValue} index={1} dir={theme.direction}>
              <div className='details-traffic-count'>
                <div className='tc-card'>
                    <label>Station</label>
                    <div className='md-body-card-details'>
                      <StationCard sharedStation={props.sharedStation} sharedAgencyName={props.sharedAgencyName} stationData={props.stationData} volumeCountDate={volumeCountDate} volumeClassCountDate={volumeClassCountDate} traffiSpeedCountDate={traffiSpeedCountDate}/>
                    </div>
                </div>
                <div className='tc-card' style={{margin:'0px 16px'}}>
                    <label>Count date</label> 
                    <Card className='tb-details-info card-count-date-info' style={{width:'100%',padding:'25px 12px'}}>                    
                      <Select             
                          className="select-dp"                             
                          value={selectedDate} 
                          onChange={(e) => dateChange(e)}
                          height='38px'   
                          style={{width:'376px'}}   
                          IconComponent={ExpandMoreIcon} 
                          MenuProps={{PaperProps:{className:'slct-details-data-type'}}}                       
                      >
                        {dateArr && dateArr.length > 0 ?
                            dateArr.map((val, index) => {
                                return <MenuItem value={ dateVal[index] }>{val}</MenuItem>
                            })
                            :
                            <option value=''>{'No data available'}</option>
                        }                      
                      </Select>
                    </Card>
                </div>
                <div className='tc-card'>
                  <label>Data type</label>
                  <Card className='tb-details-info card-data-type-info' style={{width:'100%',padding:'25px 12px'}}>
                    <Select             
                          className="select-dp"                             
                          value={dataType} 
                          onChange={(e) => dataTypeChange(e)}
                          height='38px'   
                          style={{width:'376px'}}   
                          IconComponent={ExpandMoreIcon}    
                          MenuProps={{PaperProps:{className:'slct-details-data-type'}}}                    
                      >
                        <MenuItem value={'Volume'} disabled={!volumeHasData}>Volume</MenuItem>
                        <MenuItem value={'Classification'} disabled={!classHasData}>Classification</MenuItem>
                        <MenuItem value={'Speed'} disabled={!speedHasData}>Speed</MenuItem>
                                            
                    </Select>
                  </Card> 
                </div>
              </div>
              <div className='details-tf-study'>                                          
                {dataType=='Volume'?<SummaryVolume
                  getCombinedData={getCombinedData}
                  getDirectionName={getDirectionName}
                  getDirectionNameTab={getDirectionNameTab}
                  getNBData={getNBData}
                  getSBData={getSBData}
                />:null}
                {dataType=='Speed'?<SummarySpeed
                  getSpeedData={getSpeedData}
                  getDirectionSpeedName={getDirectionSpeedName}
                  getDirectionSpeedNameTab={getDirectionSpeedNameTab}
                />:null}                
                <div className='data-chart-details'>
                {dataType=='Volume'?<Tabs value={tabValueDataType} onChange={handleChangeTabDataType} className='tb-charts-directions' aria-label="basic tabs example">
                    {(getDirectionName!="" && getDirectionNameTab!="")?<Tab label="Combined" {...a11yProps(0)} />:null}
                    {getDirectionName!=""?<Tab label={getDirectionName} {...a11yProps(1)}  />:null}
                    {getDirectionNameTab!=""?<Tab label={getDirectionNameTab} {...a11yProps(2)}  />:null}                              
                  </Tabs>:null}
                  {dataType=='Speed'?<Tabs value={tabValueDataType} onChange={handleChangeTabDataType} className='tb-charts-directions' aria-label="basic tabs example">
                    {(getDirectionSpeedName!="" && getDirectionSpeedNameTab!="")?<Tab label="Combined" {...a11yProps(0)} />:null}
                    {getDirectionSpeedName!=""?<Tab label={getDirectionSpeedName} {...a11yProps(1)}  />:null}
                    {getDirectionSpeedNameTab!=""?<Tab label={getDirectionSpeedNameTab} {...a11yProps(2)}  />:null}                              
                  </Tabs>:null}  
                  {dataType=='Classification'?<Tabs value={tabValueDataType} onChange={handleChangeTabDataType} className='tb-charts-directions' aria-label="basic tabs example">
                    {(getDirectionClassName!="" && getDirectionClassNameTab!="")?<Tab label="Combined" {...a11yProps(0)} />:null}
                    {getDirectionClassName!=""?<Tab label={getDirectionClassName} {...a11yProps(1)}  />:null}
                    {getDirectionClassNameTab!=""?<Tab label={getDirectionClassNameTab} {...a11yProps(2)}  />:null}                              
                  </Tabs>:null}                 
                </div>
              </div>
              <div className='details-tf-study'>
                <div className='data-chart-details'>
                  {(dataType == 'Volume')?<>
                    <TabPanel value={tabValueDataType} index={0}>    
                      <div className='mb-chart-details-gd'>                                            
                        <VolumeChart data={getData.dir12}/>                          
                      </div>                   
                      </TabPanel>
                      <TabPanel value={tabValueDataType} index={1}>
                        <div className='mb-chart-details-gd'>                                              
                          <VolumeChart data={getData.dir1}/>                                   
                        </div>                            
                      </TabPanel>
                      <TabPanel value={tabValueDataType} index={2}>                            
                        <div className='mb-chart-details-gd'>                            
                          <VolumeChart data={getData.dir2}/>                              
                        </div>     
                    </TabPanel>
                  </>:null}
                  {(dataType == 'Speed')?<>      
                    <TabPanel value={tabValueDataType} index={0}>                       
                      <div className='mb-chart-details-gd'>
                        <SpeedChart data={getSpeedData.combine}/>          
                      </div>           
                      </TabPanel>
                      <TabPanel value={tabValueDataType} index={1}>    
                        <div className='mb-chart-details-gd'>
                          <SpeedChart data={getSpeedData.data1}/>         
                        </div>
                      </TabPanel>
                      <TabPanel value={tabValueDataType} index={2}>    
                        <div className='mb-chart-details-gd'>
                          <SpeedChart data={getSpeedData.data2}/>         
                        </div>
                    </TabPanel>
                  </>:null}

                  {(dataType == 'Classification')?<>      
                    <TabPanel value={tabValueDataType} index={0}>                       
                      <div className='mb-chart-details-gd'>
                        <ClassificationChart data={getClassData.combine}/>                     
                      </div>
                      </TabPanel>
                      <TabPanel value={tabValueDataType} index={1}>    
                        <div className='mb-chart-details-gd'>
                          <ClassificationChart data={getClassData.data1}/>         
                        </div>
                      </TabPanel>
                      <TabPanel value={tabValueDataType} index={2}>    
                        <div className='mb-chart-details-gd'>
                          <ClassificationChart data={getClassData.data2}/>         
                        </div>
                    </TabPanel>
                  </>:null}

                </div>
              </div>                              
                
              </TabPanel>  
              </SwipeableViews>           
             </div>
           </div>  
          </Modal>   
        </React.Fragment>
    );        
}

export default MidBlock;